import DatePicker from './drawer-picker/date-picker';
import MonthPicker from './drawer-picker/month-picker';
import RangePicker from './drawer-picker/range-picker';
import YearPicker from './drawer-picker/year-picker';
import DateRangePicker from './drawer-picker/date-range-picker';
import YearRangePicker from './drawer-picker/year-range-picker';
import MonthRangePicker from './drawer-picker/month-range-picker';
import MinutePicker from './drawer-picker/minute-picker';
import { default as EmbedDateTimePicker } from './embed-picker/date-time-picker';
import EmbedMonthPicker from './embed-picker/month-picker';
import EmbedYearPicker from './embed-picker/year-picker';
import EmbedDatePicker from './embed-picker/date-picker';
import EmbedMinutePicker from './embed-picker/minute-picker';
import EmbedTimePicker from './embed-picker/time-picker';
import MinuteRangePicker from './drawer-picker/minute-range-picker';
import './styles/index.scss';
const ExpandedDatePicker = DatePicker;
ExpandedDatePicker.YearPicker = YearPicker;
ExpandedDatePicker.MonthPicker = MonthPicker;
ExpandedDatePicker.MinutePicker = MinutePicker;
ExpandedDatePicker.RangePicker = RangePicker;
ExpandedDatePicker.DateRangePicker = DateRangePicker;
ExpandedDatePicker.MonthRangePicker = MonthRangePicker;
ExpandedDatePicker.YearRangePicker = YearRangePicker;
ExpandedDatePicker.MinuteRangePicker = MinuteRangePicker;
ExpandedDatePicker.EmbedDateTimePicker = EmbedDateTimePicker;
ExpandedDatePicker.EmbedDatePicker = EmbedDatePicker;
ExpandedDatePicker.EmbedMonthPicker = EmbedMonthPicker;
ExpandedDatePicker.EmbedYearPicker = EmbedYearPicker;
ExpandedDatePicker.EmbedTimePicker = EmbedTimePicker;
ExpandedDatePicker.EmbedMinutePicker = EmbedMinutePicker;
export default ExpandedDatePicker;
export { YearPicker, MonthPicker, RangePicker, EmbedDateTimePicker, EmbedMonthPicker, EmbedYearPicker, };
